import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { setAlpha, useStyle as useAntdStyle } from '@ant-design/pro-utils';
import { useContext } from 'react';
import { ProLayoutContext } from '../../context/ProLayoutContext';

var genTopNavHeaderStyle = function genTopNavHeaderStyle(token) {
  return _defineProperty({}, token.componentCls, {
    '&-header-actions': {
      display: 'flex',
      height: '100%',
      '&-item': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBlock: 0,
        paddingInline: 2,
        color: token.colorTextRightActionsItem,
        fontSize: '16px',
        cursor: 'pointer',
        borderRadius: token.radiusBase,
        '> *': {
          paddingInline: 6,
          paddingBlock: 6,
          borderRadius: token.radiusBase,
          '&:hover': {
            backgroundColor: token.colorBgRightActionsItemHover
          }
        }
      },
      '&-avatar': {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInlineStart: '16px',
        paddingInlineEnd: '16px',
        color: setAlpha(token.colorTextBase, 0.65),
        '> div': {
          height: '44px',
          color: setAlpha(token.colorTextBase, 0.65),
          paddingInline: 8,
          paddingBlock: 8,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          lineHeight: '44px',
          borderRadius: token.radiusBase,
          '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.03)'
          }
        }
      }
    }
  });
};

export function useStyle(prefixCls) {
  var _useContext = useContext(ProLayoutContext),
      header = _useContext.header;

  return useAntdStyle('RightContent', function (token) {
    var proToken = _objectSpread(_objectSpread({}, token), {}, {
      componentCls: ".".concat(prefixCls)
    }, header);

    return [genTopNavHeaderStyle(proToken)];
  });
}